import React, { useState, useCallback } from 'react';
import { Button, Card, FileUpload, ErrorAlert } from '../../../components/shared';

export default function OcrStep({ onSubmit, loading, error }) {
  const [frontCard, setFrontCard] = useState(null);
  const [backCard, setBackCard] = useState(null);
  const [frontPreview, setFrontPreview] = useState(null);
  const [backPreview, setBackPreview] = useState(null);

  const handleFileChange = useCallback((file, side) => {
    const preview = URL.createObjectURL(file);
    if (side === 'front') {
      setFrontCard(file);
      setFrontPreview(preview);
    } else {
      setBackCard(file);
      setBackPreview(preview);
    }
  }, []);

  const handleSubmit = () => {
    if (frontCard && backCard) {
      onSubmit(frontCard, backCard);
    }
  };

  return (
    <Card title="Chụp ảnh CCCD/CMND" description="Chụp rõ ràng mặt trước và mặt sau giấy tờ tùy thân">
      <ErrorAlert error={error} className="mb-4" />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <FileUpload
          label="Mặt trước"
          accept="image/jpeg,image/png,image/webp"
          preview={frontPreview}
          onChange={(f) => handleFileChange(f, 'front')}
          disabled={loading}
        />
        <FileUpload
          label="Mặt sau"
          accept="image/jpeg,image/png,image/webp"
          preview={backPreview}
          onChange={(f) => handleFileChange(f, 'back')}
          disabled={loading}
        />
      </div>

      <div className="mt-6 flex justify-end">
        <Button
          onClick={handleSubmit}
          loading={loading}
          disabled={!frontCard || !backCard}
        >
          Tiếp tục
        </Button>
      </div>
    </Card>
  );
}
